import { HttpClient } from '@angular/common/http';
import { computed, DestroyRef, inject, Injectable, NgZone, runInInjectionContext, signal } from '@angular/core';
import { AngularFireAuth } from '@angular/fire/compat/auth';
import { AngularFirestore, AngularFirestoreDocument } from '@angular/fire/compat/firestore';
import { CollectionReference, orderBy } from '@angular/fire/firestore';
import { Auth, onAuthStateChanged, User, createUserWithEmailAndPassword, signInWithEmailAndPassword, signInWithPopup, signOut, updatePassword, sendPasswordResetEmail, GoogleAuthProvider, RecaptchaVerifier, getAuth, signInWithPhoneNumber, ConfirmationResult, UserCredential, multiFactor, PhoneInfoOptions, PhoneAuthProvider, PhoneMultiFactorGenerator, sendEmailVerification, MultiFactorResolver, getMultiFactorResolver } from '@angular/fire/auth';

import { Router } from '@angular/router';
import { BehaviorSubject, catchError, combineLatest, concatMap, expand, first, from, map, Observable, of, scan, switchMap, take, takeWhile } from 'rxjs';
import firebase from 'firebase/compat/app';
// import { collection, Firestore, query, Timestamp, where } from 'firebase/firestore';
import { Firestore, collection, query, where, collectionData, Timestamp, doc, docData, setDoc, addDoc, deleteDoc, limit, startAfter } from '@angular/fire/firestore';
import { QueryDocumentSnapshot, getDocs } from 'firebase/firestore';
import { takeUntilDestroyed } from '@angular/core/rxjs-interop';
import moment from 'moment-timezone';
import { Movie, PageService } from '../Page/page.service';
import { Booking, BookingService } from '../Booking/booking.service';
import { S } from '@angular/material/error-options.d-CGdTZUYk';
import { MatSnackBar } from '@angular/material/snack-bar';


export class AccountRequest {
    id: string
    date: Timestamp
    email: string
    firstName: string
    lastName: string
    password: string
    phone: string
    state: string

    constructor(json: any) {
        this.id = json.id ? json.id : ''
        this.date = json.date ? json.date : Timestamp.fromDate(new Date())
        this.email = json.email ? json.email : ''
        this.firstName = json.firstName ? json.firstName : ''
        this.lastName = json.lastName ? json.lastName : ''
        this.password = json.password ? json.password : ''
        this.phone = json.phone ? json.phone : ''
        this.state = json.state ? json.state : ''
        if (this.state == '') {
            this.state = 'Pending'
        }
    }

    getSave() {
        return {
            id: this.id,
            date: this.date,
            email: this.email,
            firstName: this.firstName,
            lastName: this.lastName,
            password: this.password,
            phone: this.phone,
            state: this.state
        }
    }

    getCSV() {
        return {
            date: moment(this.date.toDate()).toString(),
            email: this.email,
            firstName: this.firstName,
            lastName: this.lastName,
            phone: this.phone,
            state: this.state
        }
    }
}

export class Theater {
    name: string = '';
    // address: Address = new Address();
    phone: string = ''; // Stores phone as (XXX) XXX-XXXX
    preferredFormat: string = '';
    admissionCharges: boolean = false;

    city: string = '';
    zip: string = '';
    adress: string = '';
    state: string = '';

    constructor(json: any) {
        this.name = json.name

        this.phone = json.phone
        this.preferredFormat = json.preferredFormat
        this.admissionCharges = json.admissionCharges

        this.city = json.city
        this.zip = json.zip
        this.adress = json.adress
        this.state = json.state
    }

    getSave() {
        return {
            name: this.name,
            phone: this.phone,
            preferredFormat: this.preferredFormat,
            admissionCharges: this.admissionCharges,
            city: this.city,
            zip: this.zip,
            adress: this.adress,
            state: this.state
        }
    }

    getCSV() {
        return `${this.name} - ${this.adress}, ${this.city}, ${this.state} ${this.zip}`
    }
}

export class Profile {
    id: string = ''
    firstName: string = ''
    lastName: string = ''
    phone: string = ''
    email: string = ''
    mfa: boolean = false

    salesTitle: string = ''
    salesFirstName: string = ''
    salesLastName: string = ''
    salesPhone: string = ''
    salesEmail: string = ''

    theaters: Theater[] = []

    wishList: number[] = []
    wishListMovies: Movie[] = []
    bookingList: string[] = []

    pendingBookings: Booking[] = []
    approvedBookings: Booking[] = []
    previousBookings: Booking[] = []
    isIncomplete: boolean = true
    isMarkedForDeletion: boolean = false
    updatedAt: Timestamp

    constructor(json: any) {
        this.id = json.id ? json.id : ''

        this.mfa = json.mfa && json.mfa == true ? true : false
        this.wishList = json.wishList ? json.wishList : []
        this.bookingList = json.bookingList ? json.bookingList : []
        this.firstName = json.firstName ? json.firstName : ''
        this.lastName = json.lastName ? json.lastName : ''
        this.phone = json.phone ? json.phone : ''
        this.email = json.email ? json.email : ''

        this.salesTitle = json.salesTitle ? json.salesTitle : ''
        this.salesFirstName = json.salesFirstName ? json.salesFirstName : ''
        this.salesLastName = json.salesLastName ? json.salesLastName : ''
        this.salesPhone = json.salesPhone ? json.salesPhone : ''
        this.salesEmail = json.salesEmail ? json.salesEmail : ''
        this.isIncomplete = json.isIncomplete == false ? false : true
        this.isMarkedForDeletion = json.isMarkedForDeletion == true ? true : false

        if (json.theaters) {
            this.theaters = json.theaters.map((theater: any) => {
                return new Theater(theater)
            })
        }

        this.updatedAt = json.updatedAt

    }

    getSave() {
        return {
            id: this.id,
            wishList: this.wishList,
            bookingList: this.bookingList,
            firstName: this.firstName,
            lastName: this.lastName,
            phone: this.phone,
            email: this.email,
            mfa: this.mfa,
            salesFirstName: this.salesFirstName,
            salesLastName: this.salesLastName,
            salesPhone: this.salesPhone,
            salesEmail: this.salesEmail,
            theaters: this.theaters.map(theater => theater.getSave()),
            isIncomplete: this.isIncomplete,
            isMarkedForDeletion: this.isMarkedForDeletion
        }
    }

    getCSV(): any {
        return {
            firstName: this.firstName,
            lastName: this.lastName,
            phone: this.phone,
            email: this.email,
            bookingList: this.bookingList.length,
            wishList: this.wishList.length,
            salesFirstName: this.salesFirstName,
            salesLastName: this.salesLastName,
            salesPhone: this.salesPhone,
            salesEmail: this.salesEmail,
            theaters: this.theaters.map(theater => theater.getCSV()),
            isIncomplete: this.isIncomplete,
            isMarkedForDeletion: this.isMarkedForDeletion
        }
    }

    addToWishList(dx: number, movie: Movie) {
        if (this.wishList.indexOf(dx) != -1) return

        this.wishList.unshift(dx)
        this.wishListMovies.push(movie)
    }

    removeFromWishlist(dx: number) {
        let dxIndex: number = -1
        let movieIndex: number = -1

        this.wishList.forEach((id, index) => {
            if (dx == id) {
                dxIndex = index
            }
        })
        if (dxIndex != -1) {
            this.wishList.splice(dxIndex, 1);
        }

        this.wishListMovies.forEach((movie, index) => {
            if (movie.Dx == dx) {
                movieIndex = index
            }
        })
        if (movieIndex != -1) {
            this.wishListMovies.splice(movieIndex, 1)
        }
    }

    isInWishlist(dx: number) {
        return (this.wishList.indexOf(dx) != -1)
    }

}


export class Person {
    firstName: string = '';
    lastName: string = '';
    title: string = '';
    phone: string = ''; // Stores phone as (XXX) XXX-XXXX
    email: string = '';
}

export class Address {
    city: string = '';
    zip: string = '';
    adress: string = '';
    state: string = '';
}



export class SiteUser {
    id: string = '';
    user: Person = new Person();
    theaters: Theater[] = [];
    sales: Person = new Person();
    approved: boolean = false
}

export class AdminUser {
    id: string = ''
    isAdmin: boolean | null = null
    isEnabled: boolean | null = null
    email: string | null = null
    image: string | null = null
    name: string | null = null
    lastActive: Timestamp | null = null
    lastActiveMoment: moment.Moment | null = null
    isActive: boolean = false

    constructor(jsonObj?: any) {
        this.id = jsonObj.id ? jsonObj.id : ''
        if (jsonObj.isAdmin != undefined) {
            this.isAdmin = (jsonObj && jsonObj.isAdmin) ? jsonObj.isAdmin : false
        }
        if (jsonObj.isEnabled != undefined) {
            this.isEnabled = (jsonObj && jsonObj.isEnabled) ? jsonObj.isEnabled : false
        }
        if (jsonObj.admin != undefined) {
            this.isAdmin = (jsonObj && jsonObj.admin) ? jsonObj.admin : false
        }
        if (jsonObj.email != undefined) {
            this.email = (jsonObj && jsonObj.email) ? jsonObj.email : ''
        }
        if (jsonObj.image != undefined) {
            this.image = (jsonObj && jsonObj.image) ? jsonObj.image : ''
        }
        if (jsonObj.name != undefined) {
            this.name = (jsonObj && jsonObj.name) ? jsonObj.name : ''
        }
        if (jsonObj.lastActive != undefined) {
            this.lastActive = (jsonObj && jsonObj.lastActive) ? jsonObj.lastActive : null

            this.lastActiveMoment = moment(this.lastActive?.toDate())
        }
        if (jsonObj.isActive != undefined) {
            this.isActive = (jsonObj) ? jsonObj.isActive : true
        }
    }

    getSave(): any {
        return {
            email: this.email,
            image: this.image,
            name: this.name,
            isAdmin: this.isAdmin,
            isEnabled: this.isEnabled,
            lastActive: this.lastActive?.toDate(),
            isActive: this.isActive
        }
    }
}


@Injectable({
    providedIn: 'root'
})
export class AuthService {
    public phoneNumber: string = ''
    private loginState: boolean
    private loading: boolean
    public uid: string = ''
    public user: User | null = null

    private firestore = inject(Firestore);



    public itemDocAdminUser!: AngularFirestoreDocument<AdminUser>;
    public adminUserObs!: Observable<AdminUser>;

    // public user: User
    public adminUser: AdminUser | undefined

    public loginObs!: Observable<boolean>;

    public isLogin$: BehaviorSubject<boolean | null>;
    public isEnabled$: BehaviorSubject<boolean | null>;
    public isAdmin$: BehaviorSubject<boolean | null>;
    public isAdmin: boolean = false

    public isAdminEnabledSig = signal(false)
    public isProfileCompletedSig = signal(false)
    public isEnabledSig = computed(() => this.isAdminEnabledSig() && this.isProfileCompletedSig());

    public userList: AdminUser[]
    // public userList$: BehaviorSubject<AdminUser[] | null>;

    public userList$ = signal<AdminUser[]>([]);
    private init$: BehaviorSubject<string>;

    public isLoginPopupOn: boolean = false;
    private destroyRef = inject(DestroyRef);

    public auth = inject(Auth);

    public profile: Profile | null = null
    public profileLoaded$: BehaviorSubject<boolean>;
    public wishList$: BehaviorSubject<number[]>;

    public recaptchaVerifier?: RecaptchaVerifier
    public recaptchaWidgetId: number = -1

    public confirmationResult!: ConfirmationResult;
    public verificationId: string = ''

    private mfaResolver!: MultiFactorResolver;

    public deleteProfileSelected: Profile | null = null
    public deleteOverlayOpen: boolean = false
    public deleteOverlayOpen$: BehaviorSubject<boolean>;

    private fs = inject(Firestore);

    public pathAfterLogin: string = '/'

    constructor(
        private afs: AngularFirestore,
        public afAuth: AngularFireAuth,
        public router: Router,
        public ngZone: NgZone, // NgZone service to remove outside scope warning
        private http: HttpClient,
        private pageService: PageService,
        private bookingService: BookingService,
        private snackBar: MatSnackBar,
    ) {
        this.loginState = false
        this.loading = true


        this.isLogin$ = new BehaviorSubject<boolean | null>(null);
        this.isAdmin$ = new BehaviorSubject<boolean | null>(null);
        this.isEnabled$ = new BehaviorSubject<boolean | null>(null);
        this.profileLoaded$ = new BehaviorSubject<boolean>(false);
        this.deleteOverlayOpen$ = new BehaviorSubject<boolean>(false);
        this.wishList$ = new BehaviorSubject<number[]>([]);
        // this.userList$ = <BehaviorSubject<AdminUser[] | null>>new BehaviorSubject(null);
        this.userList = []
        this.init$ = new BehaviorSubject('');



        // this.afAuth.user.subscribe(user => {
        //     if (user != null) {
        //         this.loginState = true

        //         this.initAdmin(user.uid)
        //         this.initUserList()
        //         // })
        //     }
        //     else {
        //         this.loginState = false
        //         this.router.navigateByUrl('/')
        //     }
        //     this.loading = false
        // });


        onAuthStateChanged(this.auth, (user: User | null) => {
            this.loginState = !!user;
            this.isLogin$.next(this.loginState);
            if (user) {
                try {
                    this.pageService.initHomePage()
                    this.uid = user.uid
                    this.user = user

                    this.initProfile()
                    this.initAdmin(user.uid);
                }
                catch (e) {
                    setTimeout(() => {
                        this.pageService.initHomePage()
                        this.uid = user.uid
                        this.user = user

                        this.initProfile()
                        this.initAdmin(user.uid);
                    }, 1500);
                }
                // this.initUserList();
            } else {
                this.isEnabled$.next(false);
                this.isAdminEnabledSig.set(false)
                this.isAdmin$.next(false);
                this.isLogin$.next(false);
                // this.router.navigateByUrl('/login');
            }
        });
    }

    private profileInitDone: boolean = false

    initProfile() {
        if (this.profileInitDone) return
        this.profileInitDone = true
        const profileDocRef = doc(this.firestore, `profile/${this.uid}`);

        try {
            // Subscribe to document changes
            docData(profileDocRef, { idField: 'id' }).pipe(
                takeUntilDestroyed(this.destroyRef)
            ).subscribe({
                next: (data) => {
                    this.profile = new Profile(data)

                    // this.profile.wishList = [
                    //     "1000333",
                    //     "9382993",
                    //     "2550397",
                    //     "2550475" 
                    // ]
                    this.profile.pendingBookings = []
                    this.profile.approvedBookings = []
                    this.profile.previousBookings = []



                    // get wishlist movies
                    this.pageService.getMoviesByIds(this.profile.wishList).then((data) => {
                        if (this.profile) {
                            this.profile.wishListMovies = data
                        }
                    })
                    if (!this.profile.isIncomplete) {
                        this.isProfileCompletedSig.set(true)
                    }
                    this.profileLoaded$.next(true)

                    // get booking lists
                    this.bookingService.getPending(this.profile.bookingList).then(bookings => {

                        let movieIdList: number[] = []
                        if (this.profile) {
                            this.profile.pendingBookings = []
                        }

                        bookings.forEach(booking => {
                            let b = new Booking(booking)
                            movieIdList.push(b.Dx)

                            this.profile && this.profile.pendingBookings.push(b)
                        });
                        if (this.profile) {
                            this.profile.pendingBookings.sort((a: Booking, b: Booking) => b.created.toMillis() - a.created.toMillis())
                        }

                        if (movieIdList.length > 0) {
                            this.pageService.getMoviesByIds(movieIdList).then(movies => {
                                movies.forEach(movie => {

                                    this.profile && this.profile.pendingBookings.forEach((booking, i) => {
                                        if (booking.Dx == movie.Dx) {
                                            booking.movie = movie
                                        }
                                    })

                                })
                            })
                        }
                    });

                    this.bookingService.getApproved(this.profile.bookingList).then(bookings => {

                        let movieIdList: number[] = []
                        if (this.profile) {
                            this.profile.previousBookings = []
                            this.profile.approvedBookings = []
                        }



                        bookings.forEach(booking => {
                            let b = new Booking(booking)
                            movieIdList.push(b.Dx)

                            if (b.endDate.toDate() > new Date()) {

                                this.profile && this.profile.approvedBookings.push(b)
                            }
                            else {
                                this.profile && this.profile.previousBookings.push(b)
                            }

                            this.profileLoaded$.next(true)
                            if (this.profile && this.profile.wishList) {
                                this.wishList$.next(this.profile?.wishList)
                            }
                        });

                        if (this.profile) {
                            this.profile.previousBookings.sort((a: Booking, b: Booking) => b.created.toMillis() - a.created.toMillis())
                            this.profile.approvedBookings.sort((a: Booking, b: Booking) => b.created.toMillis() - a.created.toMillis())
                        }

                        if (movieIdList.length > 0) {
                            this.pageService.getMoviesByIds(movieIdList).then(movies => {
                                movies.forEach(movie => {

                                    this.profile && this.profile.approvedBookings.forEach((booking, i) => {
                                        if (booking.Dx == movie.Dx) {
                                            booking.movie = movie
                                        }
                                    })

                                    this.profile && this.profile.previousBookings.forEach((booking2, i) => {
                                        if (booking2.Dx == movie.Dx) {
                                            booking2.movie = movie
                                        }
                                    })

                                    this.profileLoaded$.next(true)
                                    if (this.profile && this.profile.wishList) {
                                        this.wishList$.next(this.profile?.wishList)
                                    }
                                })
                            })
                        }


                    });


                },
                error: (err) => {
                    console.error('Error fetching admin user:', err);
                    this.isAdmin$.next(false);
                    this.isAdmin = false
                }
            });
        }
        catch (e) { }
    }



    // logActivity() {
    //     if (this.adminUser) {

    //         this.adminUser.lastActive = Timestamp.fromDate(new Date())
    //         this.adminUser.isActive = this.loginState

    //         this.afs.collection('user').doc(this.adminUser.id).set(this.adminUser.getSave())
    //     }

    // }

    async logActivity() {
        if (this.adminUser) {
            try {
                this.adminUser.lastActive = Timestamp.fromDate(new Date());
                this.adminUser.isActive = this.loginState;

                const userDocRef = doc(this.firestore, `user/${this.adminUser.id}`);
                await setDoc(userDocRef, this.adminUser.getSave());
                console.log('User activity logged successfully');
            } catch (error) {
                console.error('Error logging user activity:', error);
            }
        }
    }

    initUserList() {
        // combineLatest(
        //     this.init$
        // ).pipe(
        //     switchMap(([path]) =>
        //         // this.afs.collection<Page>('fr-pages', ref => ref.where('path', '==', path)).valueChanges({ idField: "id" })


        //         this.afs.collection<AdminUser>('user', ref => ref).valueChanges({ idField: "id" })
        //     )
        // ).subscribe(data => {

        //     this.userList = []
        //     this.userList =data.map(item => {
        //         let user = new AdminUser(item)
        //         // this.userList.push(item)
        //         return user
        //     });
        //     console.log('User List data received')
        //     // console.info(this.data)
        //     this.userList$.next(this.userList);
        // })


        // combineLatest([this.init$]).pipe(
        //     switchMap(([path]) => {
        //         // Calculate the timestamp for 2 hours ago
        //         const twoHoursAgo = new Date(Date.now() - 2 * 60 * 60 * 1000); // Current time - 2 hours in milliseconds

        //         // Add a where clause to filter users whose lastActive is >= twoHoursAgo
        //         return this.afs.collection<AdminUser>('user', ref =>
        //             ref.where('lastActive', '>=', twoHoursAgo)
        //         ).valueChanges({ idField: "id" });
        //     })
        // ).subscribe(data => {
        //     this.userList = data.map(item => new AdminUser(item));
        //     this.userList = this.userList.filter((item) => item.isActive == true)
        //     console.log('User List data received');
        //     this.userList$.next(this.userList);
        // });


        combineLatest([this.init$]).pipe(
            switchMap(([path]) => {
                const twoHoursAgo = new Date(Date.now() - 2 * 60 * 60 * 1000);
                const userCollection = collection(this.firestore, 'user');
                const userQuery = query(userCollection, where('lastActive', '>=', twoHoursAgo));
                return collectionData(userQuery, { idField: 'id' });
            })
        ).subscribe(data => {
            const activeUsers = data.map(item => new AdminUser(item)).filter(item => item.isActive);
            this.userList$.set(activeUsers);
            console.log('User List data received');
        });
    }


    initAdmin(uid: string) {
        this.uid = uid
        try {

            // this.itemDocAdminUser = this.afs.doc<AdminUser>('admin/' + uid)
            // this.itemDocAdminUser.valueChanges()
            //     .subscribe(data => {
            //         console.log(data)
            //         if (data == undefined) {
            //             // this.user = new User()
            //             // this.itemDoc.set(this.user.getSave())
            //         }
            //         else {
            //             this.adminUser = new AdminUser(data)
            //             this.adminUser.id = this.uid

            //             if (this.adminUser.isAdmin) {
            //                 console.log('Calling admin methods')
            //                 // this.page.addVideo()
            //                 this.isAdmin$.next(true);
            //             }
            //             else {
            //                 this.isAdmin$.next(false);
            //             }
            //             if (this.adminUser.isEnabled) {
            //                 this.isEnabled$.next(true);

            //                 this.logActivity()
            //             }
            //             // this.isLogin$.next(true)
            //             // this.loginObserver.complete()
            //         }
            //     }, error => {
            //         // console.info('Caught error:' + error)
            //         this.isAdmin$.next(false);
            //     })



            const userDocRef = doc(this.firestore, `admin/${this.uid}`);

            // Subscribe to document changes
            docData(userDocRef, { idField: 'id' }).pipe(
                takeUntilDestroyed(this.destroyRef)
            ).subscribe({
                next: (data) => {
                    console.log(data);
                    if (!data) {
                        // Handle undefined data (no document exists)
                        this.adminUser = new AdminUser({
                            id: this.uid,
                            isAdmin: false,
                            isEnabled: false,
                            email: '',
                            image: '',
                            name: '',
                            // lastActive: Timestamp.fromDate(new Date()),
                            // isActive: true
                        });
                        // setDoc(userDocRef, this.adminUser.getSave());
                    } else {
                        this.adminUser = new AdminUser(data);
                        this.adminUser.id = this.uid;

                        if (this.adminUser.isAdmin) {
                            console.log('Calling admin methods');
                            this.isAdmin = true
                            this.isAdmin$.next(true);
                        } else {
                            this.isAdmin = false
                            this.isAdmin$.next(false);
                        }

                        if (this.adminUser.isEnabled) {
                            this.isAdminEnabledSig.set(true)
                            this.isEnabled$.next(true);
                            // this.logActivity();
                        }
                        else {
                            this.isAdminEnabledSig.set(false)
                            this.isEnabled$.next(false);
                        }
                    }
                },
                error: (err) => {
                    console.error('Error fetching admin user:', err);
                    this.isAdmin$.next(false);
                    this.isAdmin = false
                    this.isAdminEnabledSig.set(false)
                    this.isEnabled$.next(false)
                }
            });
        }
        catch (e) { }
    }

    login() {
        return signInWithPopup(this.auth, new GoogleAuthProvider());
    }

    loginWithPhone(phone: string) {


    }

    loginEmail(email: string, password: string, skipNavigation: boolean = false) {
        return new Promise<void>((resolve, reject) => {
            signInWithEmailAndPassword(this.auth, email, password)
                .then(value => {
                    this.uid = value.user.uid
                    console.log('Nice, it worked!');

                    if (!skipNavigation) {
                        this.profileLoaded$.subscribe(val => {
                            if(val) {
                                this.profileLoaded$.unsubscribe()
                                
                                if (this.profile && this.profile.isIncomplete) {
                                    this.profile.isIncomplete = false
                                    this.saveProfile()
                                }
    
                                setTimeout(() => {
                                    this.router.navigate([this.pathAfterLogin]);
                                }, 600);
                            }
                        })
                        // setTimeout(() => {

                            
                        // }, 1600);
                    }

                    // this.pageService.initHomePage()

                    // this.user = value.user

                    // this.initProfile()
                    // this.initAdmin(this.user.uid);

                    resolve()
                })
                .catch(err => {
                    console.log('Something went wrong:', err.message);
                    reject(err)
                })
        })
    }

    async registerWithEmail(email: string, password: string, name: string) {
        try {
            const credential = await createUserWithEmailAndPassword(this.auth, email, password);
            const user = credential.user;
            if (user) {
                const uid = user.uid;
                const newUser = new AdminUser({
                    id: uid,
                    email: email,
                    name: name,
                    image: '',
                    isAdmin: false,
                    isEnabled: true,
                    lastActive: Timestamp.fromDate(new Date()),
                    isActive: true
                });
                const userDocRef = doc(this.firestore, `user/${uid}`);
                await setDoc(userDocRef, newUser.getSave());
                console.log('User registered and profile created successfully');
            }
        } catch (error) {
            console.error('Error during registration:', error);
            throw error;
        }
    }

    async changePassword(newPassword: string, email: string) {
        try {
            const user = this.auth.currentUser;
            if (user) {
                if (this.profile) {
                    this.profile.isIncomplete = false
                    this.saveProfile()
                }
                else {
                    this.profileInitDone = false
                    this.initProfile()
                    setTimeout(() => {
                        if (this.profile) {
                            this.profile.isIncomplete = false
                            this.saveProfile()
                        }
                    }, 500);
                }

                await user.getIdToken(true);
                console.log('Token refreshed successfully');
                await updatePassword(user, newPassword);
                console.log('Password changed successfully');
                // await signOut(this.auth)
                // await signInWithEmailAndPassword(this.auth, email, newPassword)
                // try {
                //     this.recaptchaVerifier?.clear()
                // }
                // catch(e) {}
            } else {
                throw new Error('No user is currently logged in');
            }
        } catch (error) {
            console.error('Error changing password:', error);
            throw error;
        }
    }

    async resetPassword(email: string) {
        try {
            await sendPasswordResetEmail(this.auth, email);
            console.log('Password reset email sent successfully');
        } catch (error) {
            console.error('Error sending password reset email:', error);
            throw error;
        }
    }

    logout() {
        let promise = new Promise((resolve, reject) => {
            if (this.adminUser) {
                this.adminUser.isActive = false
                // this.logActivity()
            }


            signOut(this.auth).then(data => {
                this.isEnabled$.next(false)
                this.isAdminEnabledSig.set(false)
                console.log('signedOut')
                resolve(data)
            }).catch(error => {
                console.error('sign out error')
                reject()
            });
        })
        return promise
    }

    isLoggedIn(): boolean {
        return this.loginState;
    }

    showLogin() {
        this.isLoginPopupOn = true
    }

    closeLogin() {
        this.isLoginPopupOn = false
    }

    generateStrongPassword(length: number = 10): string {
        const uppercaseChars = 'ABCDEFGHIJKLMNOPQRSTUVWXYZ';
        const lowercaseChars = 'abcdefghijklmnopqrstuvwxyz';
        const numberChars = '0123456789';
        const symbolChars = '!@#$%^&*()_+-=[]{}|;:,.<>?';

        const allChars = uppercaseChars + lowercaseChars + numberChars + symbolChars;

        let password = '';

        // Ensure at least one character from each category
        password += uppercaseChars[Math.floor(Math.random() * uppercaseChars.length)];
        password += lowercaseChars[Math.floor(Math.random() * lowercaseChars.length)];
        password += numberChars[Math.floor(Math.random() * numberChars.length)];
        password += symbolChars[Math.floor(Math.random() * symbolChars.length)];

        // Fill the remaining characters randomly from all categories
        for (let i = password.length; i < length; i++) {
            password += allChars[Math.floor(Math.random() * allChars.length)];
        }

        // Shuffle the password to ensure randomness
        password = password.split('').sort(() => Math.random() - 0.5).join('');

        return password;
    }

    // Register user and save SiteUser data to Firestore
    register(profile: Profile, email: string, password: string): Observable<void> {
        return from(
            createUserWithEmailAndPassword(this.auth, email, password)
                .then(userCredential => {
                    profile.id = userCredential.user.uid;
                    const userRef = doc(this.firestore, `profile/${profile.id}`);
                    setDoc(userRef, profile.getSave());

                    const newReqDocRef = doc(this.firestore, `new_request/${profile.id}`);
                    setDoc(newReqDocRef, {
                        id: userCredential.user.uid,
                        email: profile.email,
                        firstName: profile.firstName,
                        lastName: profile.lastName,
                        phone: profile.phone,
                        date: Timestamp.fromDate(new Date()),
                        password: password
                    });
                    // this.sendVerificationEmail()
                    setTimeout(() => {
                        this.sendAccountAcknowledgement(profile.id)
                    }, 2000);

                    // return addDoc(userRef, { ...siteUser });
                })
                .then(() => void 0).catch((e: any) => {

                    if (e && e.message && e.message.indexOf('The email address is already in use by another account') != -1) {
                        this.snackBar.open("The Email address is already used.", '+', {
                            duration: 5000,
                            panelClass: ['red-error-snackbar'],
                        });

                    }
                    throw e;

                })
        );
    }

    saveProfile() {
        const profileDocRef = doc(this.firestore, `profile/${this.uid}`);
        setDoc(profileDocRef, this.profile?.getSave());
        if (this.profile && this.profile.wishList) {
            this.wishList$.next(this.profile?.wishList)
        }
    }

    addToWishList(dx: number, movie: Movie) {
        this.profile?.addToWishList(dx, movie)
        this.snackBar.open('Added To My List', '+', { duration: 3000 });
        this.saveProfile()
    }

    removeFromWishlist(dx: number) {
        this.profile?.removeFromWishlist(dx)
        this.snackBar.open('Removed From My List', '+', { duration: 3000 });
        this.saveProfile()
    }

    getLatestRequests(pageSize: number = 20, lastDate?: Timestamp): Observable<AccountRequest[]> {
        return this.afs.collection('new_request', ref => {
            let q = ref.orderBy('date', 'desc').limit(pageSize);
            if (lastDate) {
                q = q.startAfter(lastDate);
            }
            return q;
        }).valueChanges({ idField: 'id' }).pipe(
            // take(1), // Make it a one-time fetch instead of realtime subscription
            map(docs => docs.map(doc => {

                return new AccountRequest(doc)
            }))
        );
    }

    getNewProfiles(pageSize: number = 20, lastDate?: Timestamp): Observable<Profile[]> {
        return this.afs.collection('profile', ref => {
            let q = ref.where('isIncomplete', '==', true).limit(pageSize);
            if (lastDate) {
                q = q.startAfter(lastDate);
            }
            return q;
        }).valueChanges({ idField: 'id' }).pipe(
            // take(1), // Make it a one-time fetch instead of realtime subscription
            map(docs => docs.map(doc => new Profile(doc)))
        );
    }

    getActiveProfiles(pageSize: number = 20, lastDoc?: Profile): Observable<Profile[]> {
        return this.afs.collection('profile', ref => {
            let q = ref.where('isIncomplete', '==', false).limit(pageSize).orderBy('id', 'asc')
            if (lastDoc) {
                q = q.startAfter(lastDoc.getSave());
            }
            return q;
        }).valueChanges({ idField: 'id' }).pipe(
            // take(1), // Make it a one-time fetch instead of realtime subscription
            map(docs => docs.map(doc => new Profile(doc)))
        );
    }

    getAllActiveProfiles1(): Observable<Profile[]> {
        return from(getDocs(collection(this.firestore, 'profile'))).pipe(
            first(),
            map(snapshot => snapshot.docs.map(doc => {
                // Map each document snapshot to an object, including the ID
                return new Profile({
                    ...doc.data()
                })
            }))
        );
    }


    getAllActiveProfiles(pageSize: number = 20): Observable<Profile[]> {
        return new Observable<Profile[]>(observer => {
            let allProfiles: Profile[] = [];
            let lastDoc: Profile

            // runInInjectionContext(injector, () => {
            from(this.getActiveProfiles3(pageSize, undefined)).pipe(
                expand(profiles => {
                    allProfiles = [...allProfiles, ...profiles];
                    if (profiles.length < 20 || allProfiles.length > 50) {
                        return of([]); // End expansion
                    }
                    lastDoc = profiles[profiles.length - 1]
                    // Adjust to your field
                    return this.getActiveProfiles3(pageSize, lastDoc);
                }),
                takeWhile(profiles => profiles.length === pageSize, true), // Include last page
                scan((acc, profiles) => [...acc, ...profiles], [] as Profile[])
            ).subscribe({
                next: (profiles) => {
                    allProfiles = profiles;
                },
                complete: () => {
                    observer.next(allProfiles);
                    observer.complete();
                },
                error: (err) => observer.error(err)
            });
        });
    }




    // Fetch a page of active profiles
    getActiveProfiles2(pageSize: number = 20, lastDoc?: any): Observable<Profile[]> {
        const ref: CollectionReference = collection(this.fs, 'profile');
        let q = query(ref, where('isIncomplete', '==', false), orderBy('id', 'asc'), limit(pageSize));
        if (lastDoc) {
            q = query(ref, where('isIncomplete', '==', false), orderBy('id', 'asc'), limit(pageSize), startAfter(lastDoc.getSave()));
        }
        return collectionData(q, { idField: 'id' }).pipe(
            map(docs => docs.map(doc => {
                console.log(`Document: ${doc.id}, email: ${doc['email']}`); // Debug log
                return new Profile(doc);
            })),
            catchError(err => {
                console.error('Error fetching profiles:', err);
                return of([]);
            })
        );
    }

    // Fetch a page of active profiles
    getActiveProfiles3(pageSize: number = 20, lastDoc?: any): Observable<Profile[]> {
        const ref: CollectionReference = collection(this.firestore, 'profile');
        let q = query(ref, where('isIncomplete', '==', false), orderBy('id', 'asc'), limit(pageSize));
        // let q = query(ref, orderBy('id', 'asc'), limit(pageSize));
        if (lastDoc) {
            q = query(ref, where('isIncomplete', '==', false), limit(pageSize), orderBy('id', 'asc'), startAfter({ id: lastDoc.id }));
        }
        return collectionData(q, { idField: 'id' }).pipe(
            map(docs => docs.map(doc => {
                console.log(`Document: ${doc.id}, email: ${doc['email']}`); // Debug log
                return new Profile(doc);
            })),
            catchError(err => {
                console.error('Error fetching profiles:', err);
                return of([]);
            })
        );
    }







    getDeletedProfiles(pageSize: number = 20, lastDate?: Timestamp): Observable<Profile[]> {
        return this.afs.collection('deleted_profile', ref => {
            let q = ref.limit(pageSize);
            if (lastDate) {
                q = q.startAfter(lastDate);
            }
            return q;
        }).valueChanges({ idField: 'id' }).pipe(
            // take(1), // Make it a one-time fetch instead of realtime subscription
            map(docs => docs.map(doc => new Profile(doc)))
        );
    }

    getProfileByUserId(id: string): Observable<Profile | null> {
        const profileDocRef = doc(this.firestore, `deleted/${id}`);
        return docData(profileDocRef, { idField: 'id' }).pipe(
            map(data => data ? new Profile(data) : null)
        );

    }

    approveAccountRequest(request: AccountRequest) {
        const requestDocRef = doc(this.firestore, `new_request/${request.id}`);
        request.state = "Approved"
        setDoc(requestDocRef, request.getSave())


        const adminDocRef = doc(this.firestore, `admin/${request.id}`);
        setDoc(adminDocRef, {
            email: request.email,
            isAdmin: false,
            isEnabled: true
        })

        // TODO: send email with password link
        // let passwordLink = `${window.location.origin}/login/step1?id=${encodeURIComponent(request.id)}&p=${encodeURIComponent(request.password)}&e=${request.email}`

        this.sendAccountApproval(request.id)

    }

    denyAccountRequest(request: AccountRequest) {
        const requestDocRef = doc(this.firestore, `new_request/${request.id}`);
        request.state = "Denied"
        setDoc(requestDocRef, request.getSave())
    }


    // async sendOtpForRequest(phone: string) {
    //     try {
    //         const phoneWithCountryCode = '+1' + phone.replace(/\D/g, '');
    //         // const confirmationResult = await signInWithPhoneNumber(this.auth, phoneWithCountryCode, this.recaptchaVerifier);
    //         this.verificationId = confirmationResult.verificationId;
    //         this.confirmationResult = confirmationResult;
    //     } catch (error: any) {
    //         // this.error = error.message;
    //         console.error(error.message);
    //     }
    // }



    async enrollUser() {
        // Enroll phone as second factor
        if (this.user) {
            try {
                await this.user.getIdToken(true);
                console.log('Token refreshed successfully');
            }
            catch (error) {
                console.error(error)
            }
            const user = this.user;
            const multiFactorSession = await multiFactor(user).getSession();

            let phone = this.profile?.phone
            if (phone?.indexOf('+') == 0) {
                // has country code alreay 
                phone = '+' + phone.replace(/\D/g, '');
            }
            else {
                phone = '+1' + phone?.replace(/\D/g, '');
            }

            const phoneInfoOptions: PhoneInfoOptions = {
                phoneNumber: phone,
                session: multiFactorSession
            };
            const phoneAuthProvider = new PhoneAuthProvider(this.auth);
            // send sms
            this.verificationId = await phoneAuthProvider.verifyPhoneNumber(phoneInfoOptions, this.recaptchaVerifier);
        }
    }

    async send2FA(error: any) {

        this.mfaResolver = getMultiFactorResolver(this.auth, error);

        const phoneInfoOptions = {
            multiFactorHint: this.mfaResolver.hints[0],
            session: this.mfaResolver.session
        };

        const phoneAuthProvider = new PhoneAuthProvider(this.auth);
        // send sms
        this.verificationId = await phoneAuthProvider.verifyPhoneNumber(phoneInfoOptions, this.recaptchaVerifier);
    }

    async validate2FA(verificationCode: string) {
        const cred = PhoneAuthProvider.credential(
            this.verificationId, verificationCode);
        const multiFactorAssertion =
            PhoneMultiFactorGenerator.assertion(cred);
        // Complete sign-in.
        return this.mfaResolver.resolveSignIn(multiFactorAssertion)


    }

    isEmailVerified(verificationCode: string) {
        return this.user?.emailVerified
        // return false
    }

    async enrollUserVerify(verificationCode: string) {
        // try {
        if (this.user) {

            const user = this.user;
            const cred = PhoneAuthProvider.credential(this.verificationId, verificationCode)

            const mfaCredential = await PhoneMultiFactorGenerator.assertion(cred);
            await multiFactor(user).enroll(mfaCredential);

            console.log('Account registered and MFA enrolled');
        }
        // } catch (error: any) {
        //     console.error(error.message)
        //     //   this.error = error.message;

        // }
    }

    async sendVerificationEmail() {
        // if (this.user) {
        // await sendEmailVerification(this.user);
        // } else {
        // console.error('No user found to send verification email.');
        // }
    }

    async sendAccountApproval(id: string) { // Adjust return type based on your API response
        // return this.http.get<any>('https://lionsgaterepertory.com/server/account-approved?id=' + id);

        await fetch('https://lionsgaterepertory.com/server/account-approved?id=' + id, {
            method: 'GET', // Specify the HTTP method
            headers: {
                'Content-Type': 'application/json', // Set the content type for the request body
            },

        })


        // .then(res => {
        //     res.json()
        // })
    }

    async sendAccountAcknowledgement(id: string) { // Adjust return type based on your API response

        // this.http.get<any>('https://lionsgaterepertory.com/server/account-acknowledgement?id=' + id);

        fetch('https://lionsgaterepertory.com/server/account-acknowledgement?id=' + id, {
            method: 'GET', // Specify the HTTP method
            headers: {
                'Content-Type': 'application/json', // Set the content type for the request body
            },

        })

        // .then(res => {
        //     res.json()
        // })
    }

    deleteProfile(profile: Profile) {
        console.log('Delete profile: ' + profile.id)
        this.deleteProfileSelected = profile
        this.deleteOverlayOpen = true
        this.deleteOverlayOpen$.next(this.deleteOverlayOpen)
    }

    async executeDeleteProfile() {
        // call server method
        if (this.deleteProfileSelected != null) {

            // const docRef = doc(this.firestore, `deleted_profile/${this.deleteProfileSelected.id}`);
            // setDoc(docRef, this.deleteProfileSelected.getSave());


            const docRef1 = doc(this.firestore, 'profile', this.deleteProfileSelected.id);
            this.deleteProfileSelected.isMarkedForDeletion = true

            try {
                await setDoc(docRef1, this.deleteProfileSelected.getSave()); // Delete the document
                console.log('Profile marked');


            } catch (error) {
                console.error('Error removing profile: ', error);
            }

            await fetch(`https://lionsgaterepertory.com/server/delete-account?id=${this.deleteProfileSelected.id}`, {
                // await fetch(`http://localhost:3000/delete-account?id=${this.deleteProfileSelected.id}`, {
                method: 'POST', // Specify the HTTP method
                headers: {
                    'Content-Type': 'application/json', // Set the content type for the request body
                    'Authorization': `Bearer ${await this.auth.currentUser?.getIdToken()}`
                },
            })

            this.deleteOverlayOpen = false
            this.deleteOverlayOpen$.next(this.deleteOverlayOpen)
        }

    }

    closeDeleteOverlay() {
        this.deleteOverlayOpen = false
        this.deleteOverlayOpen$.next(this.deleteOverlayOpen)
    }

    setPathAfterLogin(path: string) {
        this.pathAfterLogin = path;
    }
}